import React from 'react'

import { Typography, useDimensions } from '@telavita-core/react-design-kit'

import ModalGeneric from '../ModalGeneric'

import PreviewTableImg from 'static/images/preview-table-patients-cancellations.jpg'

import { ReactComponent as IconEye } from 'static/svg/icon-eye-graphics.svg'
import { ReactComponent as IconChat } from 'static/svg/icon-chat-graphics.svg'
import { ReactComponent as IconBlock } from 'static/svg/icon-block-graphics.svg'

import {
  Container,
  InformationList,
  InformationItem,
  Icon,
  Image,
} from './styles'

interface PatientCancellationsModalProps {
  onClose: () => void
}

export function PatientCancellationsModal({
  onClose,
}: PatientCancellationsModalProps): JSX.Element {
  const { isMobile } = useDimensions()

  const title = isMobile
    ? 'O que fazer em casos de pacientes com muitas faltas e/ou cancelamentos?'
    :  <>O que fazer em casos de <br />pacientes com muitas faltas <br />e/ou cancelamentos?</>

  return (
    <ModalGeneric
      modalTitle={title}
      hasButton
      btnText='ENTENDI'
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <Container>
        <Image 
          src={PreviewTableImg}
          alt='Tabela de pacientes que mais faltaram e cancelaram'
        />

        <InformationList>

          <InformationItem>
            <Icon>
              <IconEye />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>O objetivo de mostrar os pacientes que mais faltaram e/ou cancelaram consultas é dar o máximo de <strong>visibilidade para você gerenciar sua população.</strong></>}
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <IconChat />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>Ao notar muitas faltas de um mesmo paciente, recomendamos que <strong>entre em contato</strong> com ele quando achar necessário. O mesmo pode valer para cancelamentos. É só abrir o menu ao lado das informações para ter acesso ao <strong>telefone e e-mail</strong> do paciente.</>}
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <IconBlock />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>Caso o paciente com muitas faltas possua uma reserva de horário, seu interesse de entrar em contato com ele tem que ser ainda maior, para entender se deve <strong>cancelar a reserva.</strong></>}
            </Typography>
          </InformationItem>

        </InformationList>
      </Container>

    </ModalGeneric>
  )
}